import { useEffect, useState } from 'react';
import { debtService } from '../../../services/debtService';
import type { DebtDirection, DebtSummary } from '../../../types/debt';

const PAGE_SIZE = 10;

export function useDebtSummary(companyId: number, direction: DebtDirection) {
  const [summaries, setSummaries] = useState<DebtSummary[]>([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [includeSettled, setIncludeSettled] = useState(false);

  useEffect(() => {
    setPage(0);
  }, [direction]);

  const handleIncludeSettledChange = (value: boolean) => {
    setIncludeSettled(value);
    setPage(0);
  };

  useEffect(() => {
    let isCancelled = false;
    setLoading(true);
    setError(null);

    debtService.getSummary(companyId, direction, includeSettled, page, PAGE_SIZE)
      .then((response) => {
        if (isCancelled) return;
        setSummaries(response.content);
        setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.error('Failed to load debt summary:', err);
        if (!isCancelled) {
          setError('Не вдалося завантажити борги');
        }
      })
      .finally(() => {
        if (!isCancelled) {
          setLoading(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [companyId, direction, includeSettled, page]);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  return {
    summaries,
    loading,
    error,
    page,
    totalPages,
    handlePageChange,
    includeSettled,
    handleIncludeSettledChange,
  };
}
